import PropTypes from 'prop-types'
import styled from 'react-emotion'

const SnapGuide = styled('div')(({ type, top, left, length, colWidth }) => {
  const style = {
    lavel: 'SnapGuide-' + type,
    position: 'absolute',
    opacity: 0.9,
    pointerEvents: 'none'
  }

  switch (type) {
    case 'hRule':
      style.top = top
      style.width = '100%'
      style.height = 0
      style.borderTop = '1px dotted #2196f3'
      style.transform = 'translateY(-0.5px)' // sit on the line between px: see note in Grid.js
      break
    case 'vRule':
      style.left = left
      style.height = '100%'
      style.width = 0
      style.borderLeft = '1px dotted #2196f3'
      style.transform = 'translateX(-0.5px)' // sit on the line between px: see note in Grid.js
      break
    case 'vDistance':
      style.top = top
      style.left = left
      style.height = length
      style.width = 0
      style.borderLeft = '1px solid #c00'
      style.overflow = 'visible'
      style['&:after'] = {
        content: '""',
        display: 'block',
        position: 'absolute',
        boxSizing: 'border-box',
        width: 9,
        left: -5,
        top: 0,
        height: '100%',
        borderTop: '1px solid #c00',
        borderBottom: '1px solid #c00'
      }
      break
    case 'hDistance':
      style.top = top
      style.left = left
      style.width = length
      style.height = 0
      style.borderTop = '1px solid #c00'
      style.overflow = 'visible'
      style['&:after'] = {
        content: '""',
        display: 'block',
        position: 'absolute',
        boxSizing: 'border-box',
        width: '100%',
        top: -5,
        left: 0,
        height: 9,
        borderRight: '1px solid #c00',
        borderLeft: '1px solid #c00'
      }
      break
    case 'col':
      style.position = 'absolute'
      style.left = left
      style.width = colWidth * 2 + 1 // +1: see note in Grid.js
      style.top = colWidth
      style.bottom = colWidth
      style.background = 'rgba(128, 128, 128, 0.1)'
      style.mixBlendMode = 'difference'
      style.transform = 'translateX(-0.5px)' // sit on the line between px: see note in Grid.js
      style.marginBottom = '50vh'
      break
    default:
      return null
  }
  return style
})

SnapGuide.propTypes = {
  type: PropTypes.string.isRequired,
  top: PropTypes.number,
  left: PropTypes.number,
  length: PropTypes.number
}

export default SnapGuide
